module.exports = __webpack_public_path__ + "login-logo.7259d250e0a789d0e2d7.png";


//////////////////
// WEBPACK FOOTER
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/assets-clover/img/login-logo.png
// module id = ../../../../../src/assets-clover/img/login-logo.png
// module chunks = styles